import { store } from '../index';

//Workstations
export const API_ACTION_GETALLWORKSTATIONS = "Workstation/GetAllWorkstations";
export const API_ACTION_GETDATABYWORKSTATION = "Workstation/GetDataByWorkstationId";
export const API_ACTION_VALIDATECREDENTIALS = "Workstation/ValidateCredentials";
export const API_ACTION_GETPALLETDATABYSSCC = "Workstation/GetPalletDataBySSCC";
export const API_ACTION_GETACTIVEPRODUCTIONORDERS = "Workstation/GetActiveProductionOrders";
export const API_ACTION_GETACTIVEPRODUCTIONORDERSBYPRODUCT = "Workstation/GetActiveProductionOrdersByProduct";
export const API_ACTION_GETLABELPREVIEWBYSSCC = "Workstation/GetPrintPreview";
export const API_ACTION_PRINTLABEL = "Workstation/PrintLabel";
export const API_ACTION_GETPRODUCTDATABYEAN = "Workstation/GetProductDataByEAN";
export const API_ACTION_GETPRODUCTIONORDERSBYEAN = "Workstation/GetProductionOrdersByEAN";
export const API_ACTION_GETNEWPALLETNUMBER = "Workstation/GetNewPalletNumber";
export const API_ACTION_GETEVENTHISTORY = "Workstation/GetEventHistory";
export const API_ACTION_GETPRINTHISTORY = "Workstation/GetPrintHistory";

//Notifications
export const API_ACTION_GETLATESTNOTIFICATIONS = "Notification/GetLatestNotifications";

//Users
export const API_ACTION_AUTHENTICATEUSER = "User/Authenticate";
export const API_ACTION_GETALLMETISUSERS = "User/GetAllMetisUsers";
export const API_ACTION_GETALLBAGWEIGHERUSERS = "User/GetAllBagweigherUsers";
export const API_ACTION_CREATEMETISUSER = "User/CreateMetisUser";
export const API_ACTION_CREATEBAGWEIGHERUSER = "User/CreateBagweigherUser";
export const API_ACTION_UPDATEMETISUSER = "User/UpdateMetisUser";
export const API_ACTION_UPDATEBAGWEIGHERUSER = "User/UpdateBagweigherUser";
export const API_ACTION_GETALLMETISUSERROLES = "User/GetAllMetisUserRoles";
export const API_ACTION_GETALLMETISUSERFEATURES = "User/GetAllMetisUserFeatures";
export const API_ACTION_GETALLEDITABLEMETISUSERFEATURES = "User/GetAllEditableMetisUserFeatures";
export const API_ACTION_CHECKIFBADGENRISFREE = "User/CheckIfBadgeNumberIsFree";
export const API_ACTION_DELETEMETISUSER = "User/DeleteMetisUser";

//General
export const API_ACTION_GETSYTEMPARAMETERSBYIDLIST = "SystemParameter/GetByIdList";

export default class ApiHelper {
    static appSettings;
}

export const ComposeUri = (action) => {
    return ApiHelper.appSettings.PALLETBOXVALIDATION_API_BASE_URL + action;
}

export const getAuthHeader = () => {
    var state = store.getState();
    var token = state.user.userToken;
    return token ? 'Bearer ' + token : '';
}

